import React from "react";
import { Header } from "../components/shared";
import {
  BookingSummary,
  CheckoutFooter,
  InsuranceSelector,
} from "../components/checkout";
import "../styles/checkout/CheckoutStep2.css";
import "../styles/checkout/Checkout.css";
import "../styles/shared/BookingComponents.css";

const CheckoutStep2 = () => {
  return (
    <div className="checkout-step2-container">
      <Header />
      <main className="checkout-step2-main-content">
        <InsuranceSelector />
        <BookingSummary />
      </main>
      <CheckoutFooter />
    </div>
  );
};

export default CheckoutStep2;
